import React from "react";
import { TbLogout } from "react-icons/tb";
import { FaRegUserCircle } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { getRole } from "../../utils/GetRole";
import { getAuthUser } from "../../utils/GetAuthUser";

export const Settings = ({ settingOpen, setSetting }) => {
  const navigate = useNavigate();
  if (!settingOpen) return null;
  const role = getRole();
  const authUser = getAuthUser();
  const navigateToLogout = () => {
    navigate("/logout");
  };

  return (
    <div className=" absolute right-6  top-16 sm:top-24  2xl:right-20 z-50">
      <div className="bg-white border border-gray-200 rounded-lg shadow-lg w-48 py-2">
        <button
          onClick={() => setSetting(false)}
          className="absolute -top-2 -right-2 bg-white border border-gray-300 rounded-full p-1 text-gray-500 hover:text-black"
        >
          ✖
        </button>
        <div className="flex flex-col">
          <Link
            to={`/${role}/profile/${authUser.userId}`}
            className="w-full text-left px-4 py-2 hover:bg-gray-50 flex items-center justify-start gap-2"
          >
            <span>
              <FaRegUserCircle className="text-3xl font-bold text-primary" />
            </span>{" "}
            <span className="text-xl font-semibold font-grotesk text-primary">
              Profile
            </span>
          </Link>
          <hr />
          <Link
            to="/logout"
            className="w-full text-left px-4 py-2 hover:bg-gray-50 flex items-center justify-start gap-2"
          >
            <span>
              <TbLogout
                className="text-3xl font-bold text-primary"
                onClick={() => navigateToLogout()}
              />
            </span>{" "}
            <span className="text-xl font-semibold font-grotesk text-primary">
              Logout{" "}
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};
